module.exports = __webpack_public_path__ + "static/media/a06dc06516dbfa6a2e81e42091b0ca7.4919ab70.jpg";